"use client";

import TrustBoxContainer from "@client/components/trust-pilot";

export default function TrustpilotWidget() {
  return <TrustBoxContainer widgetType="MicroStarNoTrustScore" width="250px" />;
}
